<template>
<div>
<validation-observer ref="CampaignRules">
  <b-form>
    <b-card
      

    >
        <b-tabs pills class="mb-2">
            <b-tab active>
                <template #title>
                <feather-icon
                    icon="FileIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                />
                <span class="d-none d-sm-inline">Template</span>
                </template>
                <b-row>
                  <b-col md="12" >
                       <b-form-group>
                        <h6>Title</h6>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="title"
                                >
                            <b-form-input v-model="input.title" />
                                <small class="text-danger">{{ errors[0] }}</small>
                             </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" >
                      <b-form-group>
                        <h6>scheduled</h6>
                         
                        
                          <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="scheduled"
                                >
                            <v-select
                            placeholder="Select Type"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="Type"
                            v-model="input.scheduled"
                            :options="scheduleds"
                          
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        
                    </b-col>
                    <b-col md="6" >
                      <b-form-group>
                        <h6>From</h6>
                         
                        
                          <validation-provider
                                #default="{ errors }"
                                rules="min:0"
                                name="from"
                                >
                              <b-form-input  v-model="input.frommail" placeholder="From" />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        
                    </b-col>
                    <b-col md="6" >
                      <b-form-group>
                        <h6>Reply To</h6>
                         
                        
                          <validation-provider
                                #default="{ errors }"
                                rules="min:0"
                                name="replyto"
                                >
                              <b-form-input  v-model="input.replyto" placeholder="From" />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        
                    </b-col>
                    <b-col md="6" >
                      <b-form-group>
                        <h6>CC</h6>
                         
                        
                          <validation-provider
                                #default="{ errors }"
                                rules="min:0"
                                name="cc"
                                >
                              <b-form-input  v-model="input.cc" placeholder="CC" />
                            <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        
                    </b-col>
                    <b-col md="12" v-if="input.scheduled == 'Scheduled'">
                        <b-form-group>
                          <h6>Time picker</h6>
                           <validation-provider
                                #default="{ errors }"
                                rules="min:0"
                                name="date_sent"
                                >
                          <flat-pickr
                          v-model="input.date_sent"
                          class="form-control"
                          :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                        />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        
                        </b-form-group>
                    </b-col>
                    <b-col md="12" >
                      <b-form-group>
                        <h6>Template</h6>
                        
                           <validation-provider
                                #default="{ errors }"
                                rules="min:0"
                                name="template"
                                >
                            <v-select
                            placeholder="select template"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="title"
                            v-model="input.template"
                            :options="templates"
                            @input="changeTemplate"
                            />
                             <small class="text-danger">{{ errors[0] }}</small>
                             </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" >
                       <b-form-group>
                        <h6>Subject</h6>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="subject"
                                >
                            <b-form-input v-model="input.subject" />
                                <small class="text-danger">{{ errors[0] }}</small>
                             </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" class="q-message" >
                      <b-form-group>
                        <h6>Message</h6>
                      
                           <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="message"
                                >
                            <quill-editor
                            style="height: 350px"
                                v-model="input.message"
                            
                            />
                             <small class="text-danger">{{ errors[0] }}</small>
                             </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div ref="templateMail" v-if="input.message">
                  <table style="margin: 0 auto;max-width: 680px;border-spacing: 0px;" >
                    <tr>
                      <th style="text-align: left; padding: 10px;">
                          <img style="max-width:200px" src="https://digitalnation.sgp1.cdn.digitaloceanspaces.com/realvestor/storage/1753862411754-Group-109.png">
                      </th>
                    </tr>
                    <tr style="background: #fff;">
                      <td style="padding: 20px;">
                        <div style="text-align:right; font-weight:500; font-size:14px;">
                          {{  timestamp }}
                        </div>
                        <p style="font-size:14px;" v-html="input.message"></p>
                        <div 
                          v-for="(property, index) of propertyDetailData"   
                          :key="index"  
                          style="float: left;
                          width: 50%;
                          min-width: 300px;
                          display: inline-block;
                          height:450px;"
                        >   
                          <div style="padding: 0 15px;">
                            <a 
                              target="_blank" 
                              :href="`https://therealtors.net/condo/${property.place_name.en.replace(/\s/g,'-')}-${property.property_code}`"> 
                              <b-img   class="img_property" v-if="property.property_images[0]"
                                :src="property.property_images[0].fullfilepath"
                                style="width:100%; object-fit:cover; height:170px;"
                              />
                              <b-img   class="img_property" v-else
                                :src="'http://128.199.95.64:81/assets/images/default/property/picture.png'"
                                style="width:100%; object-fit:cover; height:170px;"/>
                            </a>
                            <h3 style="margin: 5px 0;font-size: 16px;color:#333;">
                              <a target="_blank" :href="`https://therealtors.net/condo/${property.place_name.en.replace(/\s/g,'-')}-${property.property_code}`"> 
                                <b>{{ property.place_name[currentLocale] }}</b>
                              </a> 
                              <span style="font-size: 14px;font-weight: 400;">
                                ({{property.property_code}})
                              </span>
                            </h3>
                              
                            <p style="margin:5px 0; font-size: 14px;line-height: 18px;">  
                                Zone : {{property.zone_name}}<br/>
                                <span v-if="property.bts_name"><b>BTS</b> {{ property.bts_name}} {{property.bts_distance}} M.<br/></span>
                                <span v-if="property.mrt_name"><b>MRT</b> {{  property.mrt_name }} <br/></span>
                              <span v-if="property.airport_name" >Airport Link : {{ property.airport_name }} {{ property.airportlink_distance}} M.<br/></span>
                              {{property.bedroom }} Bedroom 
                              {{property.sqm }} sqm. <br/>
                              {{ property.floors }} Floor. <br/>
                              {{property.furniture_name }}<br/>
                              <b v-if="property.price_sale != 0" style="font-size: 15px;line-height: 24px;">Sale Price : {{property.sale_price | getcomma}} THB</b><br/> 
                              <b v-if="property.price_rent != 0" style="font-size: 15px;line-height: 24px;">Rent Price : {{property.rent_price | getcomma }} THB</b>
                            </p>
                          </div>
                        </div>                                                                                   
                      </td>
                    </tr>
                    <tr>
                      <td>
                       <div style="font-size:14px; padding:20px; ">
                            <a href="https://therealtors.net/" target="_blank" >www.therealtors.net</a><br />
                            29 Soi Sukhumvit 18, <br />
                            Klongtoey, Bangkok 10110
                            tel : <a href="tel:0974265147" >: +66 97 426 5147</a><br />
                            Line : @therealtors<br />
                            whatsapp :  +66 97 426 5147<br />
                            <a href="to:info@findbangkokroom.com" >info@findbangkokroom.com</a>
                          

                        </div>                  
                      </td>
                    </tr>
                  </table>
                </div>
            </b-tab>
            <b-tab>
                <template #title>
                    <feather-icon
                    icon="UsersIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Group Email</span>
                    
                </template>
                <b-row>
                    <b-col md="6">
                        <h6 class="text-primary font-weight-bold mb-2">
              List Groups
            </h6>

            <!-- draggable -->
            <draggable
              :list="groupsMails"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move"
            >
              <b-list-group-item
                v-for="(listItem, index) in groupsMails"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :text="listItem.title.slice(0,2)" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.title }}
                    </b-card-text>
                    <small>{{ listItem.title }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
                    </b-col>
                    <b-col md="6">
                        <h6 class="text-primary font-weight-bold mb-2">
              Selectd
            </h6>

            <!-- draggable -->
            <draggable
              :list="groupsSelected"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move"
            >
              <b-list-group-item
                v-for="(listItem, index) in groupsSelected"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :text="listItem.title.slice(0,2)" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.title }}
                    </b-card-text>
                    <small>{{ listItem.title }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab>
                <template #title>
                    <feather-icon
                    icon="PackageIcon"
                    size="16"
                    class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Subscribe</span>
                    
                </template>
            <b-row>
                    <b-col md="6">
                        <h6 class="text-primary font-weight-bold mb-2">
              List Subscriber
            </h6>

            <!-- draggable -->
            <draggable
              :list="subscribes"
              tag="ul"
              group="subsc"
              class="list-group list-group-flush cursor-move"
            >
              <b-list-group-item
                v-for="(listItem, index) in subscribes"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :text="listItem.title.slice(0,2)" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.title }}
                    </b-card-text>
                    <small>{{ listItem.title }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
                    </b-col>
                    <b-col md="6">
                        <h6 class="text-primary font-weight-bold mb-2">
              Selectd
            </h6>

            <!-- draggable -->
            <draggable
              :list="subscribeSelected"
              tag="ul"
              group="subsc"
              class="list-group list-group-flush cursor-move"
            >
              <b-list-group-item
                v-for="(item, index) in subscribeSelected"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :text="item.title.slice(0,2)" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ item.title }}
                    </b-card-text>
                    <small>{{ item.title }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="mr-0 mr-sm-50"
                />
                <span class="d-none d-sm-inline">Properties</span>
              </template>
              <b-row>
                <b-col md="6">
                  <h6 class="text-primary font-weight-bold mb-2">
                    Property Lists
                  </h6>
                  <draggable
                    :list="propertyGroups"
                    tag="ul"
                    group="subsc"
                    class="list-group list-group-flush cursor-move"
                  >
                    <b-list-group-item
                      v-for="(listItem, index) in propertyGroups"
                      :key="index"
                      tag="li"
                    >
                      <div class="d-flex">
                        <b-avatar :text="listItem.title.slice(0,2)" />
                        <div class="ml-25">
                          <b-card-text class="mb-0 font-weight-bold">
                            {{ listItem.title }}
                          </b-card-text>
                          <small>{{ listItem.title }}</small>
                        </div>
                      </div>
                    </b-list-group-item>
                  </draggable>
                </b-col>
                <b-col md="6">
                  <h6 class="text-primary font-weight-bold mb-2">
                    Selectd
                  </h6>
                  <draggable
                    :list="propertyGroupSelected"
                    tag="ul"
                    group="subsc"
                    class="list-group list-group-flush cursor-move"
                  >
                    <b-list-group-item
                      v-for="(item, index) in propertyGroupSelected"
                      :key="index"
                      tag="li"
                    >
                      <div class="d-flex">
                        <b-avatar :text="item.title.slice(0,2)" />
                        <div class="ml-25">
                          <b-card-text class="mb-0 font-weight-bold">
                            {{ item.title }}
                          </b-card-text>
                          <small>{{ item.title }}</small>
                        </div>
                      </div>
                    </b-list-group-item>
                  </draggable>
                </b-col>
              </b-row>
            </b-tab>
        </b-tabs>   
         <b-button
            variant="primary"
            type="submit"
            @click.prevent="validationForm"
        >
            Submit
        </b-button>
    </b-card>
  </b-form>
</validation-observer>
</div>   
</template>
<script>
import {
  BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,BImg,BCardHeader,BCardBody,
  BTab, BTabs, BFormGroup, BForm, BCardTitle,BListGroupItem,BFormDatepicker
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import flatPickr from 'vue-flatpickr-component'

//import useSendMail from './useSendMail';
import crmStoreModule from '../crmStoreModule'
import axios from '@axios'

//validator
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'

//popup
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/* eslint-disable global-require */

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import router from '@/router'
import { quillEditor } from 'vue-quill-editor'

import moment from 'moment'

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
    components: {
        //useTemplateList,
        crmStoreModule,
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,BImg,BFormDatepicker,
        vSelect,
        BCardHeader,BCardBody,
        BCardActions,
        BTab, BTabs,
        BFormGroup, BForm, BCardTitle,
        quillEditor,
        BListGroupItem,
        Prism,
        draggable,
        BCardText,
        flatPickr,
        ValidationProvider,
        ValidationObserver
    },
    directives: {
   
     
      Ripple,
    },
    data(){
        return {
            templates:[],
            userData: JSON.parse(localStorage.getItem('userData')),
            input:{
                title:'',
                subject:'',
                frommail:'',
                replyto:'',
                cc:'',
                scheduled:'Now',
                date_sent:'',
                template:'',
                message:'',
                status:'created',
                created_by:null
            },
            userData: JSON.parse(localStorage.getItem('userData')),
            scheduleds:['Now','Scheduled'],
            groupsMails:[ ],
            subscribes:[],
            subscribeSelected:[],
            groupsSelected:[ ],
            list1: [
                {
                name: 'Paz Joya',
                email: 'girliness@spotlike.co.uk',
                },
                {
                name: 'Sunshine Cose',
                email: 'executrixship@equisized.edu',
                },
                {
                name: 'Alba Dobbin',
                email: 'bidding@demibob.or',
                },
                {
                name: 'Marlin Hinchee',
                email: 'preholding@scuffly.co.uk',
                },
            ],
            list2: [
                {
                name: 'Leia Atienza',
                email: 'unmeasurableness@interlamellar.co.uk',
                },
                {
                name: 'Lashawna Vaudrainm',
                email: 'soaking@khubber.com',
                },
                {
                name: 'Liliana Henscheid',
                email: 'lecideine@turndown.org',
                },
                {
                name: 'Keven Kolter',
                email: 'nontenure@anglicanum.co.uk',
                },
            ],
            propertyGroups: [],
            propertyGroupSelected: [],
            timestamp: null,
            propertyDetailData: [],
        }
    },
    filters: {
      getcomma: function(text){
        if(!text){
          return ''
        }

        var nStr = text;
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }

        return x1 ;
      },
    },
    setup() {
      
        const CRM_APP_STORE_MODULE_NAME = 'app-crm';
        if (!store.hasModule(CRM_APP_STORE_MODULE_NAME)) store.registerModule(CRM_APP_STORE_MODULE_NAME, crmStoreModule);
        onUnmounted(() => {
            if (store.hasModule(CRM_APP_STORE_MODULE_NAME)) store.unregisterModule(CRM_APP_STORE_MODULE_NAME)
        });
       
        
    },
    created(){
      this.input.replyto = this.userData.email
        this.getTemplates();
        this.getGroupMails();
        this.getSubscribes();
        this.getPropertyGroups();
        this.getNow();
    },
    methods:{
        async validationForm(){
          let message =  this.$refs.templateMail.innerHTML;

          this.$refs.CampaignRules.validate().then(async success => {
            if(success){
                
              if(this.subscribeSelected.length == 0 && this.groupsSelected.length == 0){
                this.$toast({
                      component: ToastificationContent,
                      props: {
                          title: 'Pelase select group email or subcriber.',
                          icon: 'AlertTriangleIcon',
                          variant: 'danger',
                      },
                  });
                  return false;
                
              }
              
              if(this.input.scheduled == 'Now'){
                let date_sent = new Date();
                let sent_time = new Date();
              
                this.input.date_sent =  moment(String(date_sent)).format('YYYY-MM-DD hh:mm:ss');
                this.input.sent_time =  moment(String(sent_time)).format('YYYY-MM-DD hh:mm:ss');


              }else{
                this.input.date_sent += ':00';
              }
               
              this.input.created_by = this.userData.id;
              this.input.subscribeSelected = this.subscribeSelected;
              this.input.groupsSelected = this.groupsSelected;
              this.input.message = message
              var data = JSON.stringify(this.input);
              let  res = await  axios.post('crm/v1/campaign-add',data);
              
              if(!res.data.success){
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: res.data.message,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                });
              }else{
                this.$router.push('/crm/campaign', () => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                        title: `Done`,
                        icon: 'CoffeeIcon',                 
                        variant: 'success',
                        text: `You have successfully Add .`,
                        },
                    })
                });
                //crm/campaign

              }
               
  
            }
          });

        },
        async getSubscribes(){
           let params = { perpage:100,offset:0, created_by:this.userData.id};
          let  data = JSON.stringify(params);
         
          let subs = await axios.post('crm/v1/subscriber-list', data);

          this.subscribes = subs.data.data;

        },
        async getGroupMails(){
          let params = { limit:100,offset:0};
          let  data = JSON.stringify(params);
         
          let groups = await axios.post('groupmail/v1/lists', data);
         
          this.groupsMails = groups.data.data;
        },
        async getTemplates(){
            let params = { perpage: 100, offset:0};
             let  data = JSON.stringify(params);
           let templates =  await   axios.post('/crm/v1/template-list', data);
           this.templates  = templates.data.data;
            

        },
        async getPropertyGroups() {
          const propertyGroup = await axios.post(`crm/v1/property-group`, {
            is_active: 1,
            order_by: 'ID ASC'
          })

          this.propertyGroups = propertyGroup?.data?.data
        },
        changeTemplate(){
            this.input.message = this.input.template.message;
        },
        getNow: function() {
          const today = new Date();
          const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          const dateTime = date +' '+ time;
          this.timestamp = dateTime;
        },
        async selectedProperties() {
          try {
            const mergedProperties = [
              ...new Set(this.propertyGroupSelected.flatMap(item => item.properties))
            ];

            const requests = mergedProperties.map(id =>
              axios.post('cache-master/v1/property-filter', {
                perpage: 1,
                offset: 0,
                is_active: 1,
                byID: id
              })
            );

            const responses = await Promise.all(requests);

            const propertyData = responses
              .map(res => res?.data?.data?.[0])
              .filter(Boolean);
              
            this.propertyDetailData = propertyData;
          } catch (error) {
            console.error('Error fetching property data:', error);
          }
        },
    },
    watch: {
      propertyGroupSelected: {
        handler() {
          this.selectedProperties();
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      currentLocale() {
        return  this.$i18n.locale;
      },
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/ui-feather.scss';
ul.list-group {
  border: 1px solid #ccc;
  padding: 20px;

}
.q-message{
    height: 450px;
}
</style>
